import {
  Icon,
  OverflowMenuItem,
  tailwindOverride,
  Typography,
} from '@getsynapse/design-system';
import intl from 'react-intl-universal';
import { DASHBOARD_DETAIL_ACTIONS } from '../../../../utils/constants/dashboard';
import { useCallback, useContext, useState } from 'react';
import { DashboardContext } from '../../DashboardContext';
import EditDashboardNameModal from '../../../DashboardsListPage/components/EditDashboard/EditDashboardNameModal';
import { useAppThunkDispatch } from '../../../../state/store';
import { getDashboardByIdWithRelationships } from '../../../../state/normalized/dashboard/dashboardSlice';
import { DashboardSubPath } from '../../../../api/normalized/dashboard/dashboardAPI';

export const EditNameOverflowMenuItem = () => {
  const { dashboardId } = useContext(DashboardContext);
  const dispatch = useAppThunkDispatch();

  const [editDashboardNameModalOpen, setEditDashboardNameModalOpen] =
    useState(false);

  const item = {
    label: intl.get('DASHBOARDS_LIST_PAGE.TABLE.ACTION.EDIT'),
    iconName: 'pencil-outline',
    onSelect: () => {
      setEditDashboardNameModalOpen(true);
    },
    action: DASHBOARD_DETAIL_ACTIONS.EDIT,
  };

  const handleAfterEditDashboardName = useCallback(
    (dashboardId: string) => {
      dispatch(
        getDashboardByIdWithRelationships({
          dashboardId,
          relationship: DashboardSubPath.CARDS,
        })
      );
    },
    [dispatch]
  );

  return (
    <>
      <EditDashboardNameModal
        isOpen={editDashboardNameModalOpen}
        afterEditDashboard={handleAfterEditDashboardName}
        onCloseModal={() => setEditDashboardNameModalOpen(false)}
      />
      <OverflowMenuItem
        key={item.label}
        className='flex items-center space-x-2'
        onSelect={item.onSelect}
        data-cy={`dashboard-${dashboardId}__actions-popover__${item.action}`}
      >
        <Icon
          name={item.iconName || ''}
          className={tailwindOverride(
            'fill-current text-primary group-hover:fill-current group-hover:text-secondary-darker text-lg'
          )}
        />
        <Typography
          variant='label'
          className='group-hover:text-secondary-darker cursor-pointer'
        >
          {item.label}
        </Typography>
      </OverflowMenuItem>
    </>
  );
};
